module.exports = __webpack_public_path__ + "static/media/euro-parts.d8c8d668.png";